import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Params } from '@angular/router';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { FormRendererDefinitionResponse, FormSubmitResponse } from '../models/form-definition.model';
import { isFileValue } from '../utils/file-size';

@Injectable({ providedIn: 'root' })
export class SecureUploadService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiBaseUrl;

  getForm(formId: string, queryParams: Params = {}): Observable<FormRendererDefinitionResponse> {
    return this.http.get<FormRendererDefinitionResponse>(`${this.base}/api/secureupload/${formId}`, {
      params: queryParams,
    });
  }

  /** Resolves a public secure-upload identifier (from legacy /SecureUpload/External/{id} links) to its formId. */
  resolveExternal(secureUploadIdentifier: string): Observable<{ formId: string }> {
    return this.http.get<{ formId: string }>(
      `${this.base}/api/secureupload/external/${secureUploadIdentifier}`,
    );
  }

  submitForm(formId: string, formValue: Record<string, unknown>): Observable<FormSubmitResponse> {
    const fd = new FormData();
    fd.append('formId', formId);
    const values: Record<string, string> = {};
    for (const [key, val] of Object.entries(formValue)) {
      if (isFileValue(val)) {
        const files = Array.isArray(val) ? val : [val];
        files.forEach(f => fd.append(key, f, f.name));
      } else {
        values[key] = val != null ? String(val) : '';
      }
    }
    fd.append('values', JSON.stringify(values));
    return this.http.post<{ secureUploadSuccess: boolean }>(`${this.base}/api/secureupload/submit`, fd).pipe(
      map(() => ({ submissionId: '', orderId: '', documentReference: '', signerReferences: [] })),
    );
  }
}
